import { IBookingReceipt, IEventV2 } from '@travelnest/typewriter';
import { get } from 'lodash';
import { ApiRequestError } from '../../api/errors';
import { ActionTypeNames, ActionValues, createActionCreators } from '../../store/actions';
import { ThunkAction } from '../../store/middleware';
import { DateFormats, getFullDateUtc } from '../../view/components/date-picker/helpers';
import { IFXRates } from '../../view/pages/property/bookings/details/helpers';

export const getFXRateOnDateActions = createActionCreators<
	{ T: 'GET_FX_RATES_FOR_EVENT_REQUEST' },
	{ T: 'GET_FX_RATES_FOR_EVENT_RECEIVE', P: { id: string; rates: IFXRates; } },
	{ T: 'GET_FX_RATES_FOR_EVENT_FAILURE', P: { receipts: IBookingReceipt[], to: string, error: ApiRequestError } }
>('GET_FX_RATES_FOR_EVENT_REQUEST', 'GET_FX_RATES_FOR_EVENT_RECEIVE', 'GET_FX_RATES_FOR_EVENT_FAILURE');

export const getFXRateByEvent = (event: IEventV2): ThunkAction => async (dispatch, getState, { _deprecatedApi: api }) => {
	dispatch(getFXRateOnDateActions.GET_FX_RATES_FOR_EVENT_REQUEST());
	const receipts = get(event, 'booking.guest_receipts.receipts', [])
		.filter((gr: IBookingReceipt) => gr.method !== 'fx movement')
		.map(
			(gr: IBookingReceipt) => (
				// FX rates are fetched according to the UTC timezone, so match the receipt dates to this to make sure a date always exists to be fetched
				{ ...gr, date: getFullDateUtc(gr.date, DateFormats.YearMonthDay) }
			)
		) as any[];
	const bookingCurrency = get(event, 'booking.value.breakdown.channel.cash_receipt_currency');
	// FX rates are fetched according to the UTC timezone, so match the current date to this to make sure a date always exists to be fetched
	const today = getFullDateUtc(new Date(), DateFormats.YearMonthDay);

	const to = get(event, 'booking.value.breakdown.channel.converted_cash_receipt_currency');
	try {
		const rates = {};
		rates[today] = { fxRate: await api.fx.getFXRateOnDate(bookingCurrency, to, today), from: bookingCurrency, to };
		await Promise.all(
			receipts.map(async (receipt) => {
				if (receipt.currency !== to) {
					rates[receipt.date] = { fxRate: await api.fx.getFXRateOnDate(receipt.currency, to, receipt.date), from: receipt.currency, to };
				}
			})
		);

		dispatch(getFXRateOnDateActions.GET_FX_RATES_FOR_EVENT_RECEIVE({ id: event.id, rates }));

	} catch (error) {
		dispatch(getFXRateOnDateActions.GET_FX_RATES_FOR_EVENT_FAILURE({ receipts, to, error }));
		throw error;
	}
};

const actions = { ...getFXRateOnDateActions };

export type FXActions = ActionValues<typeof actions>;
type FXActionTypes = ActionTypeNames<FXActions>;
export const ActionTypes = Object.keys(actions).reduce((types, t) => {
	types[t] = t;
	return types;
}, {} as FXActionTypes);
